import { useContext } from 'react';
import { OutlinedInput, InputLabel, InputAdornment, Box } from '@mui/material';
import PropTypes from 'prop-types';
import { MobileInputStyles as classes } from './MobileInputStyles';
import { CommonStyles } from '../CommonStyles';
import { commonUtility } from '../UtilityFunctions';
import LeadGenerationContext from '../../../context/LeadGenerationContext';
import { isWebComponentFlow } from '../../commonCode';

export const MobileInput = ({
  id,
  dataTestId,
  required = false,
  ariaLabelForInputLabel,
  label,
  location,
  inputLabelSX,
  handleChange,
  placeholder,
  fullWidth = false,
  phoneValue,
  maxLength,
  inputMode,
  phoneError,
  areaCodeError,
  maxLengthOfAreaCode,
  areaCodeInputMode,
  areaCodeAriaLabel,
  areaCodeId,
  areaCode,
  disabled,
  isBundle = false,
}) => {
  const leadGenerationContext = useContext(LeadGenerationContext);
  console.log({ context: leadGenerationContext?.flow });
  const baseContext = isWebComponentFlow();
  console.log({ baseContext: baseContext.loginDetails, baseContext });
  const commonStyles = CommonStyles(baseContext?.theme);
  const { theme, isLightTheme } = baseContext;
  // const commonSelectFunction = (data1, data2) => {
  //   let data;
  //   if (data1) {
  //     data = data1;
  //   } else {
  //     data = data2;
  //   }
  //   return data;
  // };

  const phoneErr = Boolean(phoneError);
  const areaErr = Boolean(areaCodeError);
  const labelText = label || '';

  const rootSx = [
    { ...commonStyles.outlined_inputs, paddingLeft: '0 !important' },
    disabled &&
      (isBundle
        ? {
            backgroundColor: `${theme?.palette?.disabledAddress?.main} !important`,
            color: theme?.palette?.disabled?.main,
            WebkitTextFillColor: theme?.palette?.disabled?.main,
          }
        : commonStyles.outlined_inputs_disabled),
    ...(isBundle
      ? [
          commonStyles.customBorderRadius,
          commonStyles.outlined_input_bundle,
          {
            '&.Mui-focused': {
              border: `1px solid ${theme?.palette?.primary?.main}`,
            },
          },
          {
            backgroundColor: theme?.palette?.fieldsBackground?.main,
            border: `1px solid ${theme?.palette?.fieldsBorder?.main}`,
          },
        ]
      : [
          {
            '&.Mui-focused': {
              border: `1px solid ${theme?.palette?.primary?.main}`,
            },
          },
        ]),
    isBundle && phoneErr ? { backgroundColor: '#D5151F1A' } : 'none',
  ];

  const notchedOutlineSx = [
    phoneErr ? commonStyles.notchedOutlineErr : commonStyles.notchedOutline,
    isBundle && commonStyles.customBorderRadius,
  ];

  const inputSx = [
    commonStyles.input,
    disabled && {
      WebkitTextFillColor: theme?.palette?.disabled?.main,
      color: theme?.palette?.disabled?.main,
    },
    isBundle && phoneErr ? { backgroundColor: '#D5151F1A' } : 'none',
  ];

  return (
    <>
      <InputLabel
        htmlFor={commonUtility(id)}
        required={required}
        aria-label={commonUtility(ariaLabelForInputLabel)}
        sx={[
          commonStyles.label_title,
          inputLabelSX,
          isBundle && (phoneErr || areaErr) && { color: '#FD0000' },
        ]}
      >
        {labelText}
      </InputLabel>
      {location !== 'VI' ? (
        <OutlinedInput
          id={id}
          data-testid={commonUtility(dataTestId)}
          name={commonUtility(id)}
          disabled={disabled}
          onChange={handleChange}
          placeholder={placeholder}
          fullWidth={fullWidth}
          value={commonUtility(phoneValue)}
          autoComplete="off"
          inputProps={{
            maxLength,
            inputMode: inputMode || 'numeric',
            'data-testid': id,
            'aria-invalid': phoneErr,
          }}
          sx={rootSx}
          slotProps={{
            root: {
              sx: isBundle ? commonStyles.customBorderRadius : {},
            },
            notchedOutline: {
              sx: notchedOutlineSx,
            },
            input: {
              sx: {
                ...inputSx,
                '&:-webkit-autofill': {
                  WebkitBoxShadow: '0 0 0 1000px transparent inset !important',
                  WebkitTextFillColor:
                    isBundle && !isLightTheme ? '#ffffff !important' : 'inherit !important',
                  transition: 'background-color 5000s ease-in-out 0s',
                },
                padding: '11.5px 14px 11.5px 0px !important',
                fontSize: '16px',
                ...(disabled && {
                  WebkitTextFillColor: 'unset !important',
                }),
                ...(isBundle && {
                  '::-moz-placeholder': {
                    color: theme?.palette?.fieldsPlaceholder?.main,
                    opacity: 1,
                  },
                  '::placeholder': {
                    color: theme?.palette?.fieldsPlaceholder?.main,
                    opacity: 1,
                    fontSize: '16px',
                  },
                  '::-webkit-input-placeholder': {
                    color: theme?.palette?.fieldsPlaceholder?.main,
                    opacity: 1,
                  },
                  '::-ms-input-placeholder': {
                    color: theme?.palette?.fieldsPlaceholder?.main,
                    opacity: 1,
                  },
                }),
              },
            },
            adornedEnd: {
              sx: commonStyles.adorned_end,
            },
          }}
          startAdornment={
            <InputAdornment
              position="start"
              style={{
                marginRight: '0',
                minWidth: '70px',
                // ...(isBundle && phoneErr ? { backgroundColor: '#D5151F1A' } : {}),
              }}
              className="personal_mo_number"
            >
              <OutlinedInput
                inputProps={{
                  maxLength: maxLengthOfAreaCode,
                  inputMode: areaCodeInputMode || 'numeric',
                  'aria-label': areaCodeAriaLabel || null,
                  'data-testid': areaCodeId,
                  'aria-invalid': areaErr,
                  style: { fontSize: '16px' },
                }}
                disabled={disabled}
                id={areaCodeId}
                name={commonUtility(areaCodeId)}
                style={{
                  width: '70px',
                  fontSize: '16px',
                  // ...(isBundle && phoneErr ? { backgroundColor: '#D5151F1A' } : {}),
                }}
                slotProps={{
                  input: {
                    sx: {
                      ...(disabled && {
                        WebkitTextFillColor: 'unset !important',
                      }),
                      ...(isBundle && {
                        '::-moz-placeholder': {
                          color: theme?.palette?.fieldsPlaceholder?.main,
                          opacity: 1,
                        },
                        '::placeholder': {
                          color: theme?.palette?.fieldsPlaceholder?.main,
                          opacity: 1,
                          fontSize: '16px',
                        },
                        '::-webkit-input-placeholder': {
                          color: theme?.palette?.fieldsPlaceholder?.main,
                          opacity: 1,
                        },
                        '::-ms-input-placeholder': {
                          color: theme?.palette?.fieldsPlaceholder?.main,
                          opacity: 1,
                        },
                      }),
                    },
                  },
                }}
                onChange={handleChange}
                autoComplete="off"
                value={commonUtility(areaCode || '')}
                sx={{ ...classes.area_code_input, color: theme?.palette?.primary?.main }}
              />
            </InputAdornment>
          }
        />
      ) : (
        <OutlinedInput
          id={id}
          data-testid={commonUtility(dataTestId)}
          name={commonUtility(id)}
          sx={[
            commonStyles.outlined_inputs_Mobile,
            inputLabelSX,
            isBundle && phoneErr ? { backgroundColor: '#D5151F1A' } : 'none',
          ]}
          onChange={handleChange}
          placeholder={placeholder}
          fullWidth={fullWidth}
          value={commonUtility(phoneValue)}
          autoComplete="off"
          inputProps={{
            maxLength,
            inputMode,
            'data-testid': id,
            'aria-invalid': phoneErr,
          }}
          style={{
            paddingLeft: '0px',
            backgroundColor: isBundle && phoneErr ? '#D5151F1A' : 'none',
          }}
          classes={{
            notchedOutline: !phoneErr
              ? commonStyles.notchedOutline
              : commonStyles.notchedOutlineErr,
          }}
        />
      )}
    </>
  );
};

MobileInput.propTypes = {
  id: PropTypes.string,
  dataTestId: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  ariaLabelForInputLabel: PropTypes.string,
  label: PropTypes.string,
  location: PropTypes.string,
  handleChange: PropTypes.func,
  placeholder: PropTypes.string,
  fullWidth: PropTypes.bool,
  phoneValue: PropTypes.string,
  maxLength: PropTypes.number,
  inputMode: PropTypes.string,
  phoneError: PropTypes.string,
  areaCodeError: PropTypes.string,
  maxLengthOfAreaCode: PropTypes.number,
  areaCodeInputMode: PropTypes.string,
  areaCodeAriaLabel: PropTypes.string,
  areaCodeId: PropTypes.string,
  areaCode: PropTypes.string,
  inputLabelSX: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  isBundle: PropTypes.bool,
};
